{
  "last12months": "Kontosalden",
  "currentAllocation": "Aktuelle Aufteilung (nur positive Anlagen)",
  "goToReports": "Zu den Reports",
  "mostRecentTransactions": "Letzte Transaktionen",
  "mostRecentQuotes": "Letzte Bewertungen",
  "currentInformation": "Aktuelle Daten",
  "currentPositions": "Aktueller Bestand",
  "cannotDisplayNegative1": "Für eine der Kombinationen der ausgewälten Parameter hat sich eine negative Summe ergeben: ",
  "cannotDisplayNegative2": ". Dieses Diagramm kann das leider nicht richtig darstellen. Benutze eine andere Kombination.",
  "rebalancing": "Rebalancing",
  "interest": "Zinsen",
  "principal": "Kapital"
}
